function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import { removeDeepObserver } from '@netless/forge-room';
import { elementsUndoOrigin } from '../../utils/constant';
export class ElementModel {
  // 矢量数据发生变化后调用

  // 哪些属性变化后需要调用 onVectorUpdate

  get index() {
    return this.root.get(ElementModel.KEYS.index);
  }
  get uuid() {
    return this.root.get(ElementModel.KEYS.uuid);
  }
  get type() {
    return this.root.get('type');
  }
  get role() {
    return this.root.get('role') ?? 'normal';
  }
  get isBackground() {
    return this.role === 'background';
  }
  get strokeWidth() {
    return this.root.get(ElementModel.KEYS.strokeWidth);
  }
  set strokeWidth(v) {
    this.root.set(ElementModel.KEYS.strokeWidth, v);
  }
  get strokeColor() {
    return this.root.get(ElementModel.KEYS.strokeColor);
  }
  set strokeColor(value) {
    this.root.set(ElementModel.KEYS.strokeColor, value);
  }
  get fillColor() {
    return this.root.get(ElementModel.KEYS.fillColor);
  }
  set fillColor(value) {
    this.root.set(ElementModel.KEYS.fillColor, value);
  }
  get dashArray() {
    return this.root.get(ElementModel.KEYS.dashArray);
  }
  set dashArray(value) {
    this.root.set(ElementModel.KEYS.dashArray, value);
  }
  get pointsMatrix() {
    return this.root.get(ElementModel.KEYS.pointsMatrix) || [1, 0, 0, 1, 0, 0];
  }
  get points() {
    const list = this.root.get(ElementModel.KEYS.points);
    if (list) {
      return list.toArray();
    }
    return [];
  }
  set ownerId(value) {
    this.root.set(ElementModel.KEYS.ownerId, value);
  }
  get ownerId() {
    return this.root.get(ElementModel.KEYS.ownerId);
  }
  get ctrlId() {
    return this.root.get(ElementModel.KEYS.ctrlId);
  }
  set ctrlId(value) {
    this.root.set(ElementModel.KEYS.ctrlId, value);
  }

  // shadow 为 "" 表示父元素是 [main scope].activeLayer
  // shadow 为 "layer" 表示父元素是 [shadow scope].activeLayer
  // 其他, 表示父元素是 [shadow scope].activeLayer[child.uuid=shadow]
  get shadow() {
    return this.root.get(ElementModel.KEYS.shadow) ?? '';
  }
  set shadow(value) {
    this.root.set(ElementModel.KEYS.shadow, value);
  }
  get isPerformanceEnvironment() {
    return this.isPerformanceMode() && this.shouldUseLocalPoints;
  }
  isAttached() {
    return this.root.has(ElementModel.KEYS.uuid);
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    _defineProperty(this, "shadowEmitter", null);
    _defineProperty(this, "root", void 0);
    _defineProperty(this, "scope", void 0);
    _defineProperty(this, "item", void 0);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", void 0);
    _defineProperty(this, "shouldUseLocalPoints", void 0);
    _defineProperty(this, "localPointsPick", void 0);
    _defineProperty(this, "liveCursor", void 0);
    _defineProperty(this, "appendPointsTimer", null);
    _defineProperty(this, "setPointsTimer", null);
    _defineProperty(this, "pointsUpdateTimer", null);
    _defineProperty(this, "isPerformanceMode", void 0);
    _defineProperty(this, "localPoints", []);
    _defineProperty(this, "handlePropChange", events => {
      if (!this.item) {
        return;
      }
      for (const event of events) {
        if (event.target === this.root) {
          const updatePaperItemKeys = this.vectorKeys().concat([ElementModel.KEYS.pointsMatrix]);
          for (const [key, value] of event.changes.keys.entries()) {
            if (value.action === 'update' || value.action == 'add') {
              const includeKeys = this.styleKeys().include;
              if (includeKeys.indexOf(key) >= 0) {
                this.onStyleKeyUpdate(key);
                return;
              }
              if (updatePaperItemKeys.indexOf(key) >= 0) {
                this.onVectorUpdate();
              } else if (key === ElementModel.KEYS.strokeColor) {
                this.item.strokeColor = new this.scope.Color(this.strokeColor);
              } else if (key === ElementModel.KEYS.fillColor && this.fillColor) {
                this.item.fillColor = new this.scope.Color(this.fillColor);
              } else if (key === ElementModel.KEYS.strokeWidth) {
                this.item.strokeWidth = this.strokeWidth;
              } else if (key === ElementModel.KEYS.dashArray) {
                this.item.dashArray = this.dashArray;
              } else if (key === ElementModel.KEYS.shadow) {
                if (this.shadow !== '') {
                  this.shadowEmitter?.emit('translateIn', [this.uuid], this.shadow);
                } else {
                  const ownerId = this.root.get(ElementModel.KEYS.ownerId);
                  if (ownerId) {
                    this.liveCursor.updateCursorVisible(false, ownerId);
                  }
                  this.shadowEmitter?.emit('translateOut', [this.uuid], value.oldValue);
                }
              }
            }
          }
        } else if (event.target === this.root.get(ElementModel.KEYS.points)) {
          if (this.isPerformanceEnvironment) {
            this.handlePointsChangePerformance();
          } else {
            this.handlePointsChangeDirect();
          }
        } else {
          // todo log
        }
      }
    });
    _defineProperty(this, "onPointsArrayChange", points => {
      if (this.localPoints.length >= points.length) {
        return;
      }
      const pointsChunk = points.slice(this.localPoints.length, this.localPoints.length + this.localPointsPick);
      this.localPoints = this.localPoints.concat(pointsChunk);
      this.onVectorUpdate();
      this.pointsUpdateTimer = window.requestAnimationFrame(() => {
        this.onPointsArrayChange(points);
      });
    });
    this.isPerformanceMode = isPerformanceMode;
    this.scope = scope;
    this.liveCursor = liveCursor;
    this.root = root;
    if (this.root.doc) {
      if (!this.root.has(ElementModel.KEYS.pointsMatrix)) {
        // matrix: [a, b, c, d, tx, ty] http://paperjs.org/reference/matrix/#matrix-values
        this.root.set(ElementModel.KEYS.pointsMatrix, [1, 0, 0, 1, 0, 0]);
      }
    } else {
      this.root.set(ElementModel.KEYS.pointsMatrix, [1, 0, 0, 1, 0, 0]);
    }
  }
  bindObserver() {
    removeDeepObserver(this.root, this.handlePropChange);
    this.subBindObserver();
    this.root.observeDeep(this.handlePropChange);
  }
  mutationOrigin() {
    return elementsUndoOrigin;
  }
  subBindObserver() {}
  handlePointsChangeDirect() {
    this.onVectorUpdate();
    const liveCursorPoint = this.liveCursorPoint();
    const ownerId = this.root.get(ElementModel.KEYS.ownerId);
    if (liveCursorPoint && ownerId) {
      this.liveCursor.updateCursorPosition(liveCursorPoint, this.root.get(ElementModel.KEYS.ownerId));
    }
  }
  handlePointsChangePerformance() {
    const liveCursorPoint = this.liveCursorPoint();
    const ownerId = this.root.get(ElementModel.KEYS.ownerId);
    if (liveCursorPoint && ownerId) {
      this.liveCursor.updateCursorPosition(liveCursorPoint, this.root.get(ElementModel.KEYS.ownerId));
    }
    if (this.liveCursor.userManager.selfId !== ownerId || this.localPoints.length === 0) {
      if (this.pointsUpdateTimer) {
        window.cancelAnimationFrame(this.pointsUpdateTimer);
      }
      if (this.shadow == '') {
        this.localPoints = this.points;
        this.onVectorUpdate();
      } else {
        if (this.clearLocalPointsWhenYPointsChange) {
          this.localPoints = [];
        }
        this.onPointsArrayChange(this.points);
      }
    }
  }
  createPaperElement() {
    this.createPaperItem();
    if (this.item) {
      this.item.data.uuid = this.uuid;
      this.item.data.index = this.index;
      this.item.data.type = this.root.get('type');
      this.item.data.role = this.role;
      this.item.data.ownerId = this.ownerId;
      this.item.applyMatrix = false;
    }
  }
  appendPoints(points) {
    if (this.isPerformanceEnvironment) {
      return this.appendPointsPerformance(points);
    } else {
      return this.appendPointsDirect(points);
    }
  }
  getPointsArray() {
    const yArray = this.root.get(ElementModel.KEYS.points);
    return yArray instanceof Y.Array ? yArray : null;
  }
  appendPointsDirect(points) {
    const yArray = this.getPointsArray();
    if (!yArray) {
      return false;
    }
    yArray.push(points);
    return true;
  }
  appendPointsPerformance(points) {
    const yArray = this.getPointsArray();
    if (!yArray) {
      return false;
    }
    this.localPoints = this.localPoints.concat(points);
    this.onVectorUpdate();
    if (this.appendPointsTimer) {
      window.clearTimeout(this.appendPointsTimer);
    }
    if (this.localPoints.length % 80 === 0) {
      yArray?.push(this.localPoints.slice(yArray.length));
    }
    this.appendPointsTimer = window.setTimeout(() => {
      this.appendPointsTimer = null;
      if (this.localPoints.length > 0) {
        const nextArray = this.getPointsArray();
        nextArray?.push(this.localPoints.slice(nextArray.length));
      }
    }, 100);
    return true;
  }
  setPoints(points) {
    if (this.isPerformanceEnvironment) {
      return this.setPointsPerformance(points);
    } else {
      return this.setPointsDirect(points);
    }
  }
  setPointsDirect(points) {
    if (this.root.doc) {
      const yArray = this.getPointsArray();
      if (!yArray) {
        return false;
      }
      this.root.doc.transact(() => {
        yArray.delete(0, yArray.length);
        yArray.push(points);
      }, this.mutationOrigin());
    } else {
      const yArray = this.getPointsArray() || new Y.Array();
      yArray.delete(0, yArray.length);
      yArray.push(points);
      this.root.set(ElementModel.KEYS.points, yArray);
    }
    return true;
  }
  setPointsPerformance(points) {
    if (this.root.doc && !this.getPointsArray()) {
      return false;
    }
    this.localPoints = points;
    this.onVectorUpdate();
    if (this.setPointsTimer) {
      window.clearTimeout(this.setPointsTimer);
    }
    this.setPointsTimer = window.setTimeout(() => {
      if (this.root.doc) {
        const yArray = this.getPointsArray();
        if (!yArray) {
          return;
        }
        this.root.doc.transact(() => {
          yArray.delete(0, yArray.length);
          yArray.push(points);
        }, this.mutationOrigin());
      } else {
        const yArray = this.getPointsArray() || new Y.Array();
        yArray.delete(0, yArray.length);
        yArray.push(points);
        this.root.set(ElementModel.KEYS.points, yArray);
      }
    }, 100);
    return true;
  }
  appendPointsMatrix(matrix) {
    const current = new this.scope.Matrix(this.pointsMatrix);
    const next = matrix.appended(current);
    if (this.root.doc) {
      this.root.doc.transact(() => {
        this.root.set(ElementModel.KEYS.pointsMatrix, [next.a, next.b, next.c, next.d, next.tx, next.ty]);
      }, this.mutationOrigin());
    } else {
      this.root.set(ElementModel.KEYS.pointsMatrix, [next.a, next.b, next.c, next.d, next.tx, next.ty]);
    }
  }
  rotateByOffset(angle, centerX, centerY) {
    const current = new this.scope.Matrix(this.pointsMatrix);
    const matrix = new this.scope.Matrix();
    matrix.rotate(angle, centerX, centerY);
    let next = matrix.appended(current);
    const r = [0, 180, 90, -180, -90].find(v => Math.abs(v - next.rotation) < 2);
    if (r !== undefined) {
      const delta = r - next.rotation;
      const matrix = new this.scope.Matrix();
      matrix.rotate(delta, centerX, centerY);
      next = matrix.appended(next);
    }
    if (this.root.doc) {
      this.root.doc.transact(() => {
        this.root.set(ElementModel.KEYS.pointsMatrix, [next.a, next.b, next.c, next.d, next.tx, next.ty]);
      }, this.mutationOrigin());
    } else {
      this.root.set(ElementModel.KEYS.pointsMatrix, [next.a, next.b, next.c, next.d, next.tx, next.ty]);
    }
    return next.rotation;
  }
  getStyleKeys() {
    const ext = this.styleKeys();
    return Array.from(new Set(['dashArray', 'strokeColor', 'fillColor', 'strokeWidth'].filter(v => ext.exclude.indexOf(v) < 0).concat(ext.include)));
  }
  dispose() {
    this.subDispose();
  }
  disposeObserver() {
    removeDeepObserver(this.root, this.handlePropChange);
  }
}
_defineProperty(ElementModel, "KEYS", {
  index: 'index',
  uuid: 'uuid',
  strokeWidth: 'strokeWidth',
  strokeColor: 'strokeColor',
  fillColor: 'fillColor',
  dashArray: 'dashArray',
  pointsMatrix: 'pointsMatrix',
  points: 'points',
  ownerId: 'ownerId',
  ctrlId: 'ctrlId',
  shadow: 'shadow'
});